import { CaretDownOutlined } from '@ant-design/icons';
import { Col, Row } from 'antd';
import { Trans } from 'react-i18next';
import NumberFormat from 'react-number-format';

import styles from './FitCulturalBar.module.css';

interface FitCulturalBarProps {
  grade?: number;
}

interface GradeProps {
  from: number;
  to: number;
  grade?: number;
}

const Grade = ({ from, to, grade }: GradeProps) => {
  if (grade === undefined || !(grade >= from && grade <= to)) {
    return null;
  }
  const left = `${((grade - from) / (to - from)) * 100}%`;
  return (
    <Col className={styles.bar__arrow} style={{ left }}>
      <Row justify="center">
        <NumberFormat displayType="text" value={grade} />
      </Row>
      <Row justify="center">
        <Trans>Resultado</Trans>
      </Row>
      <Row justify="center">
        <CaretDownOutlined className={styles.bar__icon} />
      </Row>
    </Col>
  );
};

const FitCulturalBar: React.FC<FitCulturalBarProps> = ({ grade }) => {
  return (
    <>
      <Row justify="center">
        <Col span={4}>
          <Grade grade={grade} from={0} to={25} />
        </Col>
        <Col span={3}>
          <Grade grade={grade} from={25.01} to={35} />
        </Col>
        <Col span={3}>
          <Grade grade={grade} from={35.01} to={45} />
        </Col>
        <Col span={3}>
          <Grade grade={grade} from={45.01} to={55} />
        </Col>
        <Col span={3}>
          <Grade grade={grade} from={55.01} to={65} />
        </Col>
        <Col span={3}>
          <Grade grade={grade} from={65.01} to={75} />
        </Col>
        <Col span={4}>
          <Grade grade={grade} from={75.01} to={100} />
        </Col>
      </Row>
      <Row justify="center" className={styles.bar__container}>
        <Col span={4} style={{ backgroundColor: '#E0F1F7', color: 'black' }}>
          <Row className={styles.bar__content} justify="center" align="middle">
            <Trans>Muito baixo</Trans>
          </Row>
        </Col>
        <Col span={3} style={{ backgroundColor: '#93C4E2', color: 'black' }}>
          <Row className={styles.bar__content} justify="center" align="middle">
            <Trans>Baixo</Trans>
          </Row>
        </Col>
        <Col span={3} style={{ backgroundColor: '#2ABDEF' }}>
          <Row className={styles.bar__content} justify="center" align="middle">
            <Trans>Médio baixo</Trans>
          </Row>
        </Col>
        <Col span={3} style={{ backgroundColor: '#15A7CD' }}>
          <Row className={styles.bar__content} justify="center" align="middle">
            <Trans>Médio</Trans>
          </Row>
        </Col>
        <Col span={3} style={{ backgroundColor: '#17688A' }}>
          <Row className={styles.bar__content} justify="center" align="middle">
            <Trans>Médio alto</Trans>
          </Row>
        </Col>
        <Col span={3} style={{ backgroundColor: '#034A76' }}>
          <Row className={styles.bar__content} justify="center" align="middle">
            <Trans>Alto</Trans>
          </Row>
        </Col>
        <Col span={4} style={{ backgroundColor: '#002429' }}>
          <Row className={styles.bar__content} justify="center" align="middle">
            <Trans>Muito alto</Trans>
          </Row>
        </Col>
      </Row>
      <Row justify="center" className={styles.bar__bottonText}>
        <Col span={4}>
          <Row justify="start">0</Row>
        </Col>
        <Col span={3}>
          <Row justify="start">25</Row>
        </Col>
        <Col span={3}>
          <Row justify="start">35</Row>
        </Col>
        <Col span={3}>
          <Row justify="start">45</Row>
        </Col>
        <Col span={3}>
          <Row justify="start">55</Row>
        </Col>
        <Col span={3}>
          <Row justify="start">65</Row>
        </Col>
        <Col span={4}>
          <Row justify="space-between" className={styles.bar__content}>
            <span>75</span>
            <span>100</span>
          </Row>
        </Col>
      </Row>
    </>
  );
};

export default FitCulturalBar;
